// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__UHw2W","next":"styles_next__2pxp2"};